module.exports = __webpack_public_path__ + "img/vi_vi.123edfb2.png";